import axios from "axios";
import { baseUrl } from "./utils";
import {showError} from "./error";

export const CLEAR_VERIFICATION_STATUS = "CLEAR_VERIFICATION_STATUS";
export const SET_VERIFICATION_ATTEMPT = "SET_VERIFICATION_ATTEMPT";
export const verificationStatus = {
    none: "NONE",
    inProgress: "IN_PROGRESS",
    success: "SUCCESS",
    fail: "FAIL",
    alreadyVerified: "ALREADY_VERIFIED"
}

export function clearVerificationStatus() {
    return {
        type: CLEAR_VERIFICATION_STATUS
    }
} 

export function setVerificationAttempt( status ) {
    return {
        type: SET_VERIFICATION_ATTEMPT,
        status: status
    }
}

export function requestVerification( dispatch, verification ) {
    dispatch( setVerificationAttempt( verificationStatus.inProgress ) );
    axios.get( `${baseUrl}/verification/${verification.uid}/${verification.code}` )
    .then( response => {
        if ( response.data === "You have been already verified" )
            dispatch( setVerificationAttempt( verificationStatus.alreadyVerified ) );
        else {
            dispatch( setVerificationAttempt( verificationStatus.success ) );
        }
    } )
    .catch( error => {
        dispatch(showError(error.response.data.message))
        dispatch( setVerificationAttempt( verificationStatus.fail ) );
    } );
}